import template from './tableSearch.html';
import controller from './tableSearch.controller';

let tableSearchComponent = {
  restrict: 'E',
  bindings: {
    search: '&',
    options : '=',
    metaData : '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default tableSearchComponent;



// WEBPACK FOOTER //
// ./app/components/tableSearch/tableSearch.component.js